<div class="wrapper">
    <app-dialog-title
        title="{{ 'common.complete-profile-dialog.title' | translate }}"
        (close)="close()"
        [isMobileFullScreen]="true"
    ></app-dialog-title>

    <mat-dialog-content>
        <div class="dialog-content">
            <span class="text">{{ 'common.complete-profile-dialog.text' | translate}}</span>
            <form [formGroup]="profileForm" (keyup.enter)="submit.focus(); save()">
                <app-form-select
                    [options]="genders"
                    label="{{ 'common.fields.sex' | translate }}"
                    formControlName="sex" 
                    [placeholder]="'common.select' | translate"
                >
                    <app-form-error *ngIf="sex.touched && sex.hasError('required')">
                        {{'pages.profile.errors.invalidSex' | translate }}
                    </app-form-error>
                </app-form-select>

                <app-form-datepicker 
                    label="{{'common.fields.birthdate' | translate }}" 
                    placeholder="{{'common.date' | translate }}" 
                    formControlName="birthDate" 
                    [max]="maxDate" 
                    data-cy="birthDate"
                >
                    <app-form-error *ngIf="birthDate.touched && birthDate.hasError('validateDateIsInPast')">
                    {{'common.errors.birthDateFuture' | translate }}
                    </app-form-error>
                    <app-form-error *ngIf="birthDate.touched && birthDate.hasError('required')">
                    {{'common.errors.invalidBirthDate' | translate }}
                    </app-form-error>
                </app-form-datepicker>

                <app-address-autocomplete
                    label="{{'common.fields.addressLabel' | translate }}" 
                    placeholder="{{'common.startTyping' | translate }}" 
                    formControlName="address"
                >
                    <app-form-error *ngIf="address.touched && address.hasError('required')">
                        {{'common.errors.pleaseEnterAddress' | translate }}
                    </app-form-error>
                </app-address-autocomplete>
            </form>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions >
        <button class="bciti-button no-transition bciti-button--blue-inversed" (click)="close()">
            {{ ('common.complete-profile-dialog.cancel' | translate)}}
        </button>
        <button #submit class="bciti-button no-transition bciti-button--blue" [disabled]="isLoading" (click)="save()" >
            {{ ('common.complete-profile-dialog.confirm' | translate)}}
        </button>
    </mat-dialog-actions>
</div>
